import { useState } from "react";
import { Link } from "react-router-dom";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const textOf = (it) => [it.label, it.why];

const hrefOf = (pid, it) => `/processo/${pid}${it.target || (it.kind === "doc" ? `#doc-${it.key}` : "")}`;

const PILL = { red: "bg-red-50 text-[#C2261D] ring-red-200", amber: "bg-amber-50 text-amber-800 ring-amber-200", green: "bg-emerald-50 text-emerald-700 ring-emerald-200" };

export function TodoCounts({ pid, todo, testid, pills = false }) {
  const deed = todo?.deed || [], action = todo?.action || [];
  const nAct = todo?.a_tratar_n ?? action.length;
  const label = todo?.counts?.label || (deed.length ? "" : "pronto");
  const blocked = (todo?.counts?.blocks || []).length > 0;
  const tone = blocked ? "red" : deed.length ? "amber" : "green";
  const cls = pills ? `inline-flex rounded-full px-2.5 py-0.5 ring-1 ring-inset no-underline ${PILL[tone]}` : { red: "text-[#C2261D]", amber: "text-amber-700", green: "text-green-700" }[tone];
  return (
    <span className="shrink-0 inline-flex items-center gap-2 text-[12px] font-semibold" data-testid={testid}>
      <CountList pid={pid} items={deed} title="Impede a escritura" testid={testid && `${testid}-deed`} plain={pills} className={deed.length ? "text-amber-700" : "text-green-700"}>
        <span className={cls} data-testid={testid && `${testid}-label`}>{label}</span>
      </CountList>
      <span className="text-slate-300">·</span>
      <CountList pid={pid} items={action} title="A tratar" testid={testid && `${testid}-action`} className="text-slate-600">
        <span className="text-slate-600">{nAct} a tratar</span>
      </CountList>
    </span>
  );
}

export function CountList({ pid, items = [], title, children, className = "", testid, plain = false }) {
  const [open, setOpen] = useState(false);
  if (!items.length) return children;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" onClick={(e) => e.stopPropagation()} className={plain ? className : `underline decoration-dotted underline-offset-2 hover:decoration-solid ${className}`} data-testid={testid}>{children}</button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-80 p-0 bg-white" onClick={(e) => e.stopPropagation()} data-testid={testid && `${testid}-list`}>
        <div className="px-4 pt-3 pb-2 text-sm font-semibold navy-text">{title} · {items.length}</div>
        <ul className="max-h-80 overflow-y-auto pb-2">
          {items.map((it) => { const [label, why] = textOf(it); return (
            <li key={it.id}>
              <Link to={hrefOf(pid, it)} onClick={() => setOpen(false)} className="flex gap-2.5 px-4 py-2 hover:bg-slate-50" data-testid={`count-item-${it.id}`}>
                <span className={`mt-1.5 w-2 h-2 rounded-full shrink-0 ${it.tone === "red" ? "bg-red-600" : "bg-amber-500"}`} />
                <span className="min-w-0 text-sm"><span className="text-slate-800 font-medium">{label}</span>{why && <span className="text-slate-500"> · {why}</span>}</span>
              </Link>
            </li>
          ); })}
        </ul>
      </PopoverContent>
    </Popover>
  );
}
